module.exports = __webpack_public_path__ + "img/news.71f77712.svg";